import {
  Tooltip,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Divider,
  ListItemIcon,
} from '@mui/material';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import TextsmsIcon from '@mui/icons-material/Textsms';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MouseEvent, useState } from 'react';

type INavAccountMenuProps = {
  name: string;
  onMyAccount?: () => void;
  onSettings?: () => void;
  onLogout?: () => void;
};

/**
 * Generates account menu for top nav
 * Based on https://mui.com/components/menus/#account-menu
 */
export default function NavAccountMenu({
  name,
  onMyAccount,
  onSettings,
  onLogout,
}: INavAccountMenuProps) {
  const [anchorAccEl, setAnchorAccEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorAccEl);
  const handleAccClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorAccEl(event.currentTarget);
  };
  const handleAccClose = () => {
    setAnchorAccEl(null);
  };
  return (
    <>
      <Tooltip title="Account settings">
        <IconButton
          onClick={handleAccClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <Typography sx={{ color: 'white' }} data-testid="name-container">
            {name}
          </Typography>
          <ExpandMoreIcon
            color="primary"
            sx={{
              transition: '.2s ease-in-out',
              rotate: !open ? '-90deg' : '0',
              marginLeft: 1,
            }}
          />
        </IconButton>
      </Tooltip>
      <Menu
        data-testid="submenu-container"
        anchorEl={anchorAccEl}
        id="account-menu"
        open={open}
        onClose={handleAccClose}
        onClick={handleAccClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 12,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={onMyAccount}>
          <Avatar /> My account
        </MenuItem>
        <Divider />
        {process.env['NODE_ENV'] !== 'production' && (
          <MenuItem
            onClick={() => {
              window.open('https://csadmin.typeform.com/to/NJTd4Ynf', '_blank');
            }}
          >
            <ListItemIcon>
              <TextsmsIcon fontSize="small" />
            </ListItemIcon>
            Feedback
          </MenuItem>
        )}
        <MenuItem onClick={onSettings}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem>
        <MenuItem onClick={onLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}
